export default __webpack_public_path__ + "static/media/strava-login-orange.d61a51ba.svg";